// Shared ERP ledger-sync status logic for the Partners module — imported by
// both the desktop table (ChannelPartner.jsx) and the mobile views
// (Mobile/PartnerCard.jsx, Mobile/PartnerDetail.jsx) so the two layouts can
// never derive a different status from the same row.
//
// Source of truth: CP.ledgerId (Finance ledger, numeric) and
// CP.crmLedgerDetails (CRM ledger, object with an .id) — both written by the
// externally-triggered POST /payments/createNewBroker. Neither field is
// queried specially here: getAllCpFromCpTable / the desktop CP query already
// select('*', ...), so both are already present on every row.

const LEDGER_SYNC_COLOURS = {
  synced:     { color: "#175CD3", backgroundColor: "#EFF8FF" },
  partial:    { color: "#B54708", backgroundColor: "#FFFAEB" },
  not_synced: { color: "#667085", backgroundColor: "#F2F4F7" },
};

const LEDGER_SYNC_LABELS = {
  synced: "Synced",
  partial: "Partial",
  not_synced: "Not Synced",
};

// crmLedgerDetails is written as the ERP CRM outputList object (has an .id
// field) — treat any object with a truthy .id as "present". ledgerId is a
// plain numeric column.
function hasFinanceLedger(row) {
  return row?.ledgerId !== null && row?.ledgerId !== undefined && row?.ledgerId !== "";
}

function hasCrmLedger(row) {
  return Boolean(row?.crmLedgerDetails?.id);
}

export function getLedgerSyncStatus(row) {
  const financeOk = hasFinanceLedger(row);
  const crmOk = hasCrmLedger(row);

  const status = crmOk ? "synced" : financeOk ? "partial" : "not_synced";

  return {
    status,
    label: LEDGER_SYNC_LABELS[status],
    financeOk,
    crmOk,
    ledgerId: row?.ledgerId ?? null,
    crmLedgerId: row?.crmLedgerDetails?.id ?? null,
    ...LEDGER_SYNC_COLOURS[status],
  };
}
